import styled, { css } from "styled-components"

const styledContent = css`
  max-width: 990px;

  h1 {
    margin-top: 2rem;
    font-size: 2.45em;
  }

  h2 {
    margin-top: 2rem;
    font-size: 2em;
  }

  ul {
    padding-left: 2rem;
  }

  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  img {
    position: relative;
    z-index: 3;
    width: 50%;
    float: right;
    margin-left: 20px;
    border-radius: 32px;
  }

  @media (max-width: 991px) {
    padding-bottom: 80px;
  }
`

export const StyledRow = styled.main`
  display: block;
  max-width: 1140px;
  padding: 50px 0;
  position: relative;
  margin: 0 auto;

  @media (max-width: 1199px) {
    margin-left: 20px;
    margin-right: 20px;
  }
`

export const StyledJobSection = styled.div`
  ${styledContent}
`

export const StyledSelectsWrapper = styled.div`
  display: flex;
  gap: 20px;

  @media (max-width: 993px) {
    flex-direction: column;
    gap: 5px;
  }
`

export const StyledSelect = styled.div`
  display: flex;
  flex-direction: column;

  label {
    margin-bottom: 0;
    text-transform: uppercase;
  }

  select {
    height: 1.5rem;
    font-size: 1rem;
    width: fit-content;
  }
`

export const StyledList = styled.div`
  h3 {
    font-size: 1.5em;
    color: var(--grey-darkest);
  }
`

export const StyledLink = styled.a`
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`
